import { Color } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const pdfStyles = StyleSheet.create({
  header: {
    marginBottom: 10,
  },
  h1: {
    marginBottom: 4,
    fontSize: 18,
    fontWeight: 'bold',
  },
  subTitle: {
    marginBottom: 4,
    color: Color.Grey500,
  },
  dateRange: {
    marginBottom: 10,
  },
})
